import type { RootState } from '../../configuration/setup/store';
import type { AssetTab } from './sidebarSlice';

export const SIDEBAR_DEFAULT_WIDTH = 470;
export const SIDEBAR_MIN_WIDTH = 350;
export const SIDEBAR_MODE_BREAKPOINT_MAP = 990;
export const SIDEBAR_MODE_BREAKPOINT_TABLE = 1440;

export const getSidebarTabId = (state: RootState): AssetTab => state.app.sidebar.tabId;
